module.exports = __webpack_public_path__ + "static/media/man-laptop.bf68e317.png";